import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Link,
  Snackbar,
} from "@mui/material";
import emailjs from "emailjs-com";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NutritionModal({ open, handleClose }) {
  const [email, setEmail] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Prepare the form data to be sent
    const formData = {
      email: email, // Assuming 'email' is a state variable holding the email address
      comments:
        "This is a message from the potential client seeking nutrition help", // Add other form data here
    };

    emailjs
      .send(
        "service_op7na6f",
        "template_8fnx9z9",
        formData,
        "YFMMXT0aIYIwFuUC_"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSnackbarMessage("Email successfully sent!");
          setSnackbarSeverity("success");
          handleClose(); // Close the form/modal after successful submission
        },
        (error) => {
          console.log("FAILED...", error);
          setSnackbarMessage("Failed to send email. Please try again.");
          setSnackbarSeverity("error");
        }
      )
      .finally(() => {
        setSnackbarOpen(true);
      });

    console.log("Email submitted:", email);

    console.log("Email submitted:", email);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
    background: "linear-gradient(45deg, #8A2BE2 30%, black 90%)", // Gradient from purple to black
    color: "white", // White text for better contrast
    boxShadow: "1px 1px 71px whitesmoke",
  };
  const inputStyle = {
    backgroundColor: "white", // Background color
    "& label.Mui-focused": {
      color: "purple", // Label color when the input is focused
      marginTop: "10px", // Add margin to the label (adjust as needed)
    },
    "& .MuiInputLabel-root": {
      // Style for the label in its normal state
      //   margin: "0 0 10px 0", // Add margin to the label (adjust as needed)
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "purple", // Default border color
      },
      "&:hover fieldset": {
        borderColor: "darkpurple", // Border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "purple", // Border color when focused
        borderWidth: "2px", // Make the border thicker when focused
      },
    },
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography
            variant="h6"
            component="h2"
            style={{ marginBottom: "20px" }}
          >
            Improve Your Nutrition
          </Typography>
          <Typography sx={{ mt: 2, mb: 2 }}>
            Discover sustainable lifestyle changes for better nutrition, without
            relying on fad diets.
          </Typography>
          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <TextField
              label="Your Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={inputStyle}
            />
            <Button
              type="submit"
              variant="contained"
              style={{
                backgroundColor: "purple",
                color: "white",
                marginTop: "20px",
              }}
            >
              Submit
            </Button>
          </form>
          <Typography sx={{ mt: 2 }}>
            <Link
              href="https://calendly.com/garagegymcrofton"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "white",
                textDecoration: "none",
                fontWeight: "bold", // Make the text bold
                fontSize: "1.1rem", // Slightly larger font size
              }}
            >
              Schedule a Call
            </Link>{" "}
            to discuss how we can help you with your nutrition.
          </Typography>
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
